import React from 'react';
import { Wrench } from 'lucide-react';

/**
 * Full-screen maintenance page shown to every public visitor while the
 * Admin toggle `settings.maintenance` is on. Admin routes are unaffected.
 */
const MaintenancePage = () => (
  <div
    data-testid="maintenance-page"
    className="min-h-screen bg-black text-white flex items-center justify-center px-4"
  >
    <div className="max-w-lg w-full text-center">
      <img
        src="/hydro-health-logo.png"
        alt="Hydro Health"
        className="h-10 mx-auto mb-10 opacity-90"
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />

      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#909090]/10 border border-[#909090]/30 mb-6">
        <Wrench className="text-[#909090]" size={26} strokeWidth={1.8} />
      </div>

      <p className="text-[#909090] text-sm uppercase tracking-widest mb-3">
        Scheduled maintenance
      </p>
      <h1 className="text-4xl md:text-5xl font-bold mb-5">
        We&rsquo;ll be right back.
      </h1>
      <p className="text-zinc-400 text-base leading-relaxed max-w-md mx-auto">
        Hydro Health is offline for a short update. Existing orders and
        tracking are safe. Please check back shortly &mdash; thank you for
        your patience.
      </p>

      <div className="mt-10 pt-8 border-t border-zinc-900 text-xs text-zinc-500">
        Need to reach us?{' '}
        <a
          href="mailto:support@hydrohealth.store"
          className="text-zinc-300 hover:text-white underline underline-offset-4"
        >
          support@hydrohealth.store
        </a>
      </div>
    </div>
  </div>
);

export default MaintenancePage;
